import classNames from "classnames";
import React from "react";
import { Link } from "react-router";

import { Avatar } from "../../core/atoms/atoms";
import { LabelIcon, Icomoon } from "../../core/atoms";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./ltoTestimonial.scss";

interface Props {
  quote: string;
  imageLeft: string;
  avatarImage: string;
  imageRight: string;
  quotee: string;
  country: {
    name: string;
    slug: string;
    region: string;
  };
  onClick?: (e: React.MouseEvent<Link>) => any;
}

export class LtoTestimonial extends React.Component<Props>{
  public render() {
    return (
      <div className={classNames("lto-testimonial")}>
        <Avatar className="destination-image-left" source={this.props.imageLeft} />
        <Avatar source={this.props.avatarImage} />
        <Avatar className="destination-image-right" source={this.props.imageRight} />
        <blockquote>
          <p>{this.props.quote}</p>
          <cite>
            <LabelIcon icomoon={Icomoon.user} iconColor="accent" labelTextColor="mid" labelText={this.props.quotee} />
          </cite>
          <div className="testimonial-region">
            <Link
              to={WebRoutes.country(this.props.country.slug, this.props.country.region)}
              onClick={this.props.onClick}
            >
              <LabelIcon icomoon={Icomoon.location} iconColor="accent" labelTextColor="mid" labelText={this.props.country.name} />
            </Link>
          </div>
        </blockquote>
      </div>
    );
  }
}
